"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var element_1 = require("../element");
var axis_1 = require("./axis");
var component_1 = require("./component");
var AxisWithBackground = /** @class */ (function (_super) {
    __extends(AxisWithBackground, _super);
    function AxisWithBackground() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AxisWithBackground.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this._axis = this.appendT(axis_1.Axis);
        this._ticks = this.appendGroupT(element_1.Line).options({
            _data: function (_, i) { return _this._axis.tickValues[i].map(function (x) { return ({ value: x, scaledValue: _this._axis.scales[i](x) }); }); },
            x1: function (d) { return d.scaledValue; },
            x2: function (d) { return d.scaledValue; },
            y1: 0,
            y2: 100,
        });
    };
    AxisWithBackground.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        this.setupProxy({ axis: "_axis", ticks: "_ticks" });
    };
    return AxisWithBackground;
}(component_1.Component));
exports.AxisWithBackground = AxisWithBackground;
//# sourceMappingURL=axis-with-background.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/axis-with-background.js
// module id = 1172
// module chunks = 0 1